import React from 'react'
import { useQueryClient } from 'react-query'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { handleError } from 'api/document_collection/useAPIDocumentCollection'
import ErrorBoundary from 'app/DocumentCollectionPage/components/ErrorBoundary'
import { DOCUMENT_PAGE_API_OPTIONS } from 'app/DocumentCollectionPage/configs'
import { DocumentCategoryCollectionPage } from 'app/DocumentCollectionPage/pages/DocumentCategoryCollectionPage'
import { baseUrl } from 'configs/api'

export async function getServerSideProps({ res, params, query }) {
  const { id } = params
  const { MOCK_API_URL } = query // TODO: clean up when real API ready
  const apiBaseUrl = MOCK_API_URL ?? baseUrl

  try {
    let categoryDetail = { data: null }

    res.setHeader(
      'Cache-Control',
      'public, s-maxage=600, stale-while-revalidate=1200'
    )

    const response = await fetch(
      `${apiBaseUrl}/guru/teachers/v1alpha1/document-collection/categories/${id}`,
      DOCUMENT_PAGE_API_OPTIONS
    )

    if (response.ok && response.body) {
      categoryDetail = await response.json()
    }
    const { name, description } = categoryDetail?.data ?? {
      name: 'Dokumen Rujukan',
      description: '',
    }

    return {
      props: {
        categoryDetail,
        pageTitle: `${name} - Ruang GTK`,
        pageDescription: `${description} - Ruang GTK`,
        metaTags: {},
      },
    }
  } catch (error) {
    handleError(
      error.response?.status,
      `${baseUrl}/v1alpha1/document-collection/categories/${id}`,
      error
    )

    return {
      props: {
        categoryDetail: {
          data: {
            name: 'Dokumen Rujukan',
            description: '',
            categoryType: 'CT_UNDEFINED',
          },
        },
        pageTitle: `Dokumen Rujukan - Ruang GTK`,
        pageDescription: `Dokumen Rujukan - Ruang GTK`,
        metaTags: {},
      },
    }
  }
}

export const DocumentCollectionCategoryDocumentListPageIndex = (props) => {
  const router = useRouter()
  const queryClient = useQueryClient()
  const { id } = router.query

  const { categoryDetail } = props

  const resetErrorHandler = () => {
    queryClient.refetchQueries({
      queryKey: ['category-document-collection-list'],
    })
  }

  return (
    <ErrorBoundary resetKeys={[router.asPath]} onReset={resetErrorHandler}>
      <Head>
        <title>Dokumen Rujukan - Ruang GTK</title>
      </Head>

      <DocumentCategoryCollectionPage
        id={id}
        categoryInfo={categoryDetail?.data}
      />
    </ErrorBoundary>
  )
}

// eslint-disable-next-line react/display-name
DocumentCollectionCategoryDocumentListPageIndex.Layout = ({ children }) =>
  children

export default DocumentCollectionCategoryDocumentListPageIndex
